import React, { useState, useEffect } from 'react';

import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import { makeStyles } from '@material-ui/core/styles';
import { wsGet } from 'services/WService';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Visibility } from '@material-ui/icons';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

export default WithApp(function ModalCuotaProvider(props) {
  const classes = useStyles();
  const cuota = props.model;
  const {errorZones,nameError} = props;

  const [productsDetail, setProductsDetail] = useState([]);
  const [productOrder, setProductOrder] = useState([]);
  const [checkedProducts, setCheckedProducts] = useState({});

  async function getProductOnDemand() {
    let response = await wsGet(`prog/zone-open/${errorZones.idZone}/productos-on-demand`);
    if (response.success) {
      setProductsDetail(response.data);
      const initialChecks = {};
      response.data.forEach(product => {
        initialChecks[product.ItemCode] = false;
      });
      setCheckedProducts(initialChecks);
    }
  }

  async function getPedidosOnDemand(itemCodes = []) {
    if (itemCodes.length === 0) {
      setProductOrder([]);
      return;
    }

    const query = itemCodes.map(code => `ItemCode[]=${encodeURIComponent(code)}`).join('&');
    const response = await wsGet(`prog/zone-open/${errorZones.idZone}/pedidos-on-demand?${query}`);

    if (response.success) {
      setProductOrder(response.data);
    }
  }


  useEffect(() => {
    getProductOnDemand();
  }, []);

  return (
    <>
      <Modal
        title={`Pedidos con error en el ${nameError}`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        hideSave={true}
      >
        <h4 className={classes.cardIconTitle}>Detalles de productos con error en el {nameError}</h4>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="tabla detalles de productos">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Código</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell align="center">Stock</TableCell>
                <TableCell align="center">Stock comprometido</TableCell>
              </TableRow>
            </TableHead>
              <TableBody>
                {productsDetail.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No se encontraron productos.
                    </TableCell>
                  </TableRow>
                )}

                {productsDetail.map((product, i) => (
                  <TableRow
                    key={product.ItemCode}
                  >
                    <TableCell>
                      {i + 1}
                      <Checkbox
                        checked={checkedProducts[product.ItemCode] || false}
                        onChange={(e) => {
                          const newChecked = e.target.checked;

                          setCheckedProducts(prev => {
                            const updated = {
                              ...prev,
                              [product.ItemCode]: newChecked
                            };
                            const selectedCodes = Object.keys(updated).filter(code => updated[code]);
                            getPedidosOnDemand(selectedCodes);

                            return updated;
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell>{product.ItemCode}</TableCell>
                    <TableCell>{product.ItemName}</TableCell>
                    <TableCell align="center">{parseFloat(product.OnHand).toFixed(2)}</TableCell>
                    <TableCell align="center">{parseFloat(product.IsCommited).toFixed(2)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
          </Table>
        </TableContainer>
        <br/>
        {productOrder.length > 0 && (
          <>
            <h4 className={classes.cardIconTitle}>Pedidos con error en el {nameError}</h4>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="tabla pedidos cabecera">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Total orden</TableCell>
                    <TableCell>Fecha Creación</TableCell>
                    <TableCell>Nombre Vendedor</TableCell>
                    <TableCell>Código Cliente</TableCell>
                    <TableCell>Nombre Cliente</TableCell>
                    <TableCell>Total de unidades</TableCell>
                  </TableRow>
                </TableHead>
                  <TableBody>
                    {productOrder.map((order, i) => (
                      <TableRow>
                        <TableCell>
                          {i + 1}
                          <Button justIcon round simple color="primary">
                            <Link to={`/admin/ventas/operaciones/pedidos/#${order.id}`} target="_blank">
                              <Visibility />
                            </Link>
                          </Button>
                        </TableCell>
                        <TableCell>
                          {(() => {
                            let estadoOrden = '';
                            switch (order.state_migrate) {
                              case 'X':
                                estadoOrden = 'APROBADO';
                                break;
                              case 'P':
                                estadoOrden = 'Programado';
                                break;
                              case 'G':
                                estadoOrden = 'Facturado SAP';
                                break;
                              default:
                                estadoOrden = 'Sin estado Definido';
                            }
                            return estadoOrden;
                          })()}
                        </TableCell>
                        <TableCell>{parseFloat(order.total_order).toFixed(2)}</TableCell>
                        {/* <TableCell>{order.created_at || ''}</TableCell> */}
                        <TableCell>{moment(order.created_at).format('YYYY-MM-DD hh:mm:ss') || ''}</TableCell>
                        <TableCell>{order.SlpName}</TableCell>
                        <TableCell>{order.CardCode}</TableCell>
                        <TableCell>{order.CardName}</TableCell>
                        <TableCell>{parseFloat(order.quantity_unit).toFixed(2)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </Modal>
    </>
  );
});
